// src/pages/sow-draft/PreviewModal.jsx
import PropTypes from "prop-types";
import { Button, Modal } from "../../shared/ui";

export default function PreviewModal({ open, onClose, html }) {
  return (
    <Modal
      open={open}
      title="Preview"
      onClose={onClose}
      size="xl"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div
        className="text-sm text-ink [&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-4 [&_h3]:mb-1.5 [&_p]:text-muted [&_p]:mb-3"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Modal>
  );
}

PreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  html: PropTypes.string,
};
